<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
    </div>
</template>

<script>
export default {
    name: 'App',
    provide () {
        return {
            reload: this.reload
        }
    },
    data () {
        return {
            isRouterAlive: true
        }
    },
    methods: {
        async reload () {
            this.isRouterAlive = false
            await this.$nextTick
            this.isRouterAlive = true
        }
    }

}
</script>

<style lang='scss'>
#app {
    width: 100%;
    height: 100%;
}
</style>
